/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Media_Nocovers2Inputs */

const id_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada sampul ditemukan`)
};

const ms_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada kulit ditemui`)
};

const da_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen covere fundet`)
};

const de_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Cover gefunden`)
};

const en_us2_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No covers found`)
};

const es_es2_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron portadas`)
};

const es_mx2_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron portadas`)
};

const fil_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang cover`)
};

const fr_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune couverture trouvée`)
};

const it_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna copertina trovata`)
};

const hu_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található borító`)
};

const nl_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen omslagen gevonden`)
};

const no_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen forsider funnet`)
};

const pl_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono okładek`)
};

const pt_br2_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma capa encontrada`)
};

const pt_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma capa encontrada`)
};

const ro_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit coperți`)
};

const fi_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kansia ei löytynyt`)
};

const sv_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga omslag hittades`)
};

const vi_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy bìa`)
};

const tr_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapak bulunamadı`)
};

const cs_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné obálky`)
};

const bg_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени корици`)
};

const ru_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обложки не найдены`)
};

const uk_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обкладинок не знайдено`)
};

const ar_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على أغلفة`)
};

const hi_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई कवर नहीं मिला`)
};

const th_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบปก`)
};

const ja_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カバーが見つかりません`)
};

const zh_cn2_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到封面`)
};

const zh_hant1_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到封面`)
};

const ko_offerdetail_media_nocovers2 = /** @type {(inputs: Offerdetail_Media_Nocovers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`커버를 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "No covers found" |
*
* @param {Offerdetail_Media_Nocovers2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_media_nocovers2 = /** @type {((inputs?: Offerdetail_Media_Nocovers2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Media_Nocovers2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_media_nocovers2(inputs)
	if (locale === "ms") return ms_offerdetail_media_nocovers2(inputs)
	if (locale === "da") return da_offerdetail_media_nocovers2(inputs)
	if (locale === "de") return de_offerdetail_media_nocovers2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_media_nocovers2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_media_nocovers2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_media_nocovers2(inputs)
	if (locale === "fil") return fil_offerdetail_media_nocovers2(inputs)
	if (locale === "fr") return fr_offerdetail_media_nocovers2(inputs)
	if (locale === "it") return it_offerdetail_media_nocovers2(inputs)
	if (locale === "hu") return hu_offerdetail_media_nocovers2(inputs)
	if (locale === "nl") return nl_offerdetail_media_nocovers2(inputs)
	if (locale === "no") return no_offerdetail_media_nocovers2(inputs)
	if (locale === "pl") return pl_offerdetail_media_nocovers2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_media_nocovers2(inputs)
	if (locale === "pt") return pt_offerdetail_media_nocovers2(inputs)
	if (locale === "ro") return ro_offerdetail_media_nocovers2(inputs)
	if (locale === "fi") return fi_offerdetail_media_nocovers2(inputs)
	if (locale === "sv") return sv_offerdetail_media_nocovers2(inputs)
	if (locale === "vi") return vi_offerdetail_media_nocovers2(inputs)
	if (locale === "tr") return tr_offerdetail_media_nocovers2(inputs)
	if (locale === "cs") return cs_offerdetail_media_nocovers2(inputs)
	if (locale === "bg") return bg_offerdetail_media_nocovers2(inputs)
	if (locale === "ru") return ru_offerdetail_media_nocovers2(inputs)
	if (locale === "uk") return uk_offerdetail_media_nocovers2(inputs)
	if (locale === "ar") return ar_offerdetail_media_nocovers2(inputs)
	if (locale === "hi") return hi_offerdetail_media_nocovers2(inputs)
	if (locale === "th") return th_offerdetail_media_nocovers2(inputs)
	if (locale === "ja") return ja_offerdetail_media_nocovers2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_media_nocovers2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_media_nocovers2(inputs)
	return ko_offerdetail_media_nocovers2(inputs)
});
export { offerdetail_media_nocovers2 as "offerDetail.media.noCovers" }